/**
 * StockMovement Zod schemalari — tovar harakati jurnali (Phase 1)
 *
 * Stok o'zgarishlari (kirim, sotuv, inventarizatsiya, qaytarish)
 * immutable yozuv sifatida saqlanadi.
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
import { currencyEnum } from './product.schema.js';
// ─── Enums ──────────────────────────────────────────────────────
export const stockMovementTypeEnum = z.enum([
    'IN', // Taminotchidan qabul qilindi
    'OUT', // Sotuv (kassa)
    'ADJUST_IN', // Inventarizatsiya — qo'shildi
    'ADJUST_OUT', // Inventarizatsiya — kamaydi
    'RETURN_IN', // Mijoz qaytardi
    'RETURN_OUT', // Taminotchiga qaytarildi
    'TRANSFER', // Ko'chirish (kelajak)
]);
// ─── Tezkor qabul qilish (eng ko'p ishlatiladigan) ──────────────
// UI'dan "+5 dona qabul qildim" tugmasi bosilganda yuboriladi.
export const quickReceiveSchema = z.object({
    productId: uuidSchema,
    // variantSku — agar xil bo'lsa (parent.variants[].sku)
    variantSku: z.string().min(1).max(50).optional(),
    quantity: z.coerce.number().int().min(1).max(100_000),
    // Tan narx — bu partiya uchun (FIFO/avg uchun saqlanadi)
    unitCost: z.coerce.number().min(0).optional(),
    currency: currencyEnum.optional(),
    supplierId: uuidSchema.optional(),
    note: z.string().max(500).optional(),
});
// ─── Inventarizatsiya tuzatish (qo'lda) ─────────────────────────
export const stockAdjustSchema = z.object({
    productId: uuidSchema,
    variantSku: z.string().min(1).max(50).optional(),
    // Musbat → ADJUST_IN, manfiy → ADJUST_OUT
    delta: z.coerce
        .number()
        .int()
        .refine((n) => n !== 0, "Delta 0 bo'la olmaydi"),
    note: z.string().min(3).max(500), // Sabab majburiy
});
// ─── Ro'yxat olish so'rovi ──────────────────────────────────────
export const listStockMovementsSchema = z.object({
    productId: uuidSchema.optional(),
    variantSku: z.string().max(50).optional(),
    supplierId: uuidSchema.optional(),
    type: stockMovementTypeEnum.optional(),
    dateFrom: z.string().datetime().optional(),
    dateTo: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(50),
    cursor: z.string().max(200).optional(),
});
//# sourceMappingURL=stock-movement.schema.js.map